export default function TabTitle(title) {
    document.title = title;
};

